"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThirdPartyWrapper = exports.ThirdPartyCopy = exports.Heading = exports.Body = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _LexusTypography = require("../../components/LexusTypography");
const ThirdPartyCopy = exports.ThirdPartyCopy = _styledComponents.default.div`
  margin-bottom: 30px;
`;
const Heading = exports.Heading = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "heading24"
})}
  margin: 0px 0px 20px;
`;
const Body = exports.Body = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "body14"
})}
`;
const ThirdPartyWrapper = exports.ThirdPartyWrapper = _styledComponents.default.div`
  [data-page-theme="gr"] & {
    padding: 30px 50px 85px;
    ${Heading} {
      font-family: "DecimaMonoPro";
      font-size: 28px;
      font-weight: 300;
      font-style: normal;
      color: #EC1C24;
      line-height: 120%;
    }

    ${Body} {
      font-family: 'akkurat-mono';
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 50px;
    }

    .lexus-button {
      min-width: 200px;
      padding: 0 20px;
    }
  }

  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding: 30px 65px 85px;
  ${(0, _breakpoints.default)("mobile", "down")}{
    padding: 30px 10px 85px;
  }
`;